var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.078 5.07581C14.078 5.07581 15.9378 3.57473 19.1925 3.86581C21.7489 4.09443 25.0496 6.97178 25.0496 6.97178L11.3756 20.8378C11.3756 20.8378 9.56951 22.1537 7.15949 22.2292C4.74948 22.3047 0.00182156 19.3497 0.00182156 19.3497L14.078 5.07581Z",
    fill: "url(#paint0_linear_1034_112454)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0508 6.96875L24.1699 13.193L12.0446 25.4887L12.7573 19.435L25.0508 6.96875Z",
    fill: "url(#paint1_linear_1034_112454)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5742 6.52734L42.6047 12.8416L30.0884 25.3532L30.9699 19.3087L43.5742 6.52734Z",
    fill: "url(#paint2_linear_1034_112454)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0347 6.24198C31.0347 6.24198 32.9436 3.72737 36.4477 3.51073C39.4101 3.32758 43.5919 6.53006 43.5919 6.53006L25.1537 25.2273C25.1537 25.2273 22.734 27.4372 19.589 28.0063C16.182 28.6227 12.0542 25.4892 12.0542 25.4892L31.0347 6.24198Z",
    fill: "url(#paint3_linear_1034_112454)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2537 10.9981C44.2537 10.9981 46.008 9.47214 49.3103 9.6908C51.8191 9.85693 55.0006 12.6107 55.0006 12.6107L41.2442 26.5603C41.2442 26.5603 39.6397 27.8847 37.0672 28.0253C34.2249 28.1805 30.0928 25.358 30.0928 25.358L44.2537 10.9981Z",
    fill: "url(#paint4_linear_1034_112454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_112454",
    x1: 21.8395,
    y1: 3.71662,
    x2: 2.95257,
    y2: 22.3419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1034_112454",
    x1: 26.3651,
    y1: 8.30151,
    x2: 10.5122,
    y2: 23.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98A3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1034_112454",
    x1: 44.8885,
    y1: 7.8601,
    x2: 28.6395,
    y2: 23.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1034_112454",
    x1: 40.3819,
    y1: 3.2749,
    x2: 14.9144,
    y2: 28.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E40AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B81F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1034_112454",
    x1: 51.9166,
    y1: 9.48332,
    x2: 32.9159,
    y2: 28.2208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56565"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrcLogo);
export default __webpack_public_path__ + "static/media/frc-logo.8ea1159513cf60973483099a3eeddfbc.svg";
export { ForwardRef as ReactComponent };